enum HistoryScrollRestorationEnum {
	auto = 'auto',
	manual = 'manual'
}
export default HistoryScrollRestorationEnum;
